import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { fetchHealth } from '../api/client'
import type { SystemHealth } from '../types/api'

const HEALTH_POLL_INTERVAL_MS = 15_000

/**
 * Polls `GET /api/v1/health` every 15 seconds.
 *
 * Errors (unreachable backend) are surfaced through `isError` so the status menu in the
 * top bar can show a red "API unreachable" state.
 */
export function useHealth(): UseQueryResult<SystemHealth, Error> {
  return useQuery<SystemHealth, Error>({
    queryKey: ['system', 'health'],
    queryFn: fetchHealth,
    refetchInterval: HEALTH_POLL_INTERVAL_MS,
    refetchIntervalInBackground: true,
    retry: 1,
  })
}

export { HEALTH_POLL_INTERVAL_MS }
